<template>
    <div class="row my-0 p-0 h-100 position-relative">
        <div class="d-none d-sm-block position-absolute" style="top: 5px; right: 5px; z-index: 3;">
            <button
                id="calendar-collapse"
                class="btn btn-dark text-white"
                @click="collapsed = !collapsed"
                style="line-height: 0.9;"
            >
                <i
                    class="cursor-pointer fa fa-lg text-white"
                    :class="collapsed ? 'fa-angle-double-left' : 'fa-angle-double-right'"
                ></i>
            </button>
        </div>

        <div
            class="col-12 p-sm-1 h-100"
            :class="collapsed ? 'col-sm-11 col-md-11' : 'col-sm-8 col-md-9'"
        >
            <div
                v-if="canSelectScheduleOwner"
                class="d-flex justify-content-between align-center my-2"
            >
                <label class="font-weight-bold text-nowrap mr-3"
                    >Select {{ scheduleOwnerProp }}:</label
                >
                <select
                    id="owner-select"
                    class="form-control form-control-sm"
                    v-model="scheduleOwner"
                >
                    <option v-if="scheduleOwnerList && !scheduleOwnerList.length" :value="{}"
                        >Loading...</option
                    >
                    <option v-else="" hidden selected disabled>Choose one</option>
                    <option :id="`owner-${x.id}`" v-for="x in scheduleOwnerList" :value="x">{{
                        x.name
                    }}</option>
                </select>
            </div>

            <template v-if="scheduleOwner.id">
                <div class="d-flex justify-content-start align-items-center mb-2">
                    <img
                        class="img-fluid rounded-circle mt-2 mr-2 profile-image"
                        :src="profileImage"
                    />
                    <p class="text-capitalize mb-0">
                        {{
                            `${scheduleOwner.name}${
                                scheduleOwner.title ? `, ${scheduleOwner.title}` : ""
                            }`
                        }}
                    </p>
                    <button
                        id="add-appointment"
                        class="btn btn-sm font-weight-bold text-uppercase text-white ml-3"
                        :class="
                            canCreateAppointments ? 'btn-primary' : 'btn-light cursor-not-allowed'
                        "
                        @click="canCreateAppointments ? openNewAppointmentModal() : null"
                    >
                        Add appointment
                    </button>
                    <span class="ml-auto">
                        Show weekends?
                        <toggle-button
                            :value="!!showWeekends"
                            color="#D64571"
                            @change="setShowWeekends($event.value)"
                            :sync="true"
                            :labels="true"
                        />
                    </span>
                </div>

                <div
                    dusk="calendar"
                    class="d-flex justify-content-between align-items-start position-relative"
                    style="border-radius: 5px;"
                >
                    <div
                        v-for="h in hours"
                        :style="separatorStyle(h)"
                        class="w-100 position-absolute bg-transparent"
                        style="border-top: solid 1px #8f8f8f26; min-height: 2px;"
                    ></div>
                    <div style="line-height: 1; flex-basis: 0; min-width: 3ch;">
                        <!--HOURS-->
                        <div class="text-center font-weight-bold text-uppercase p-3 calendar-head">
                            <span class="day">&nbsp;</span><br />
                            <span class="week">&nbsp;</span>
                        </div>
                        <div class="position-relative" :style="dayStyle">
                            &nbsp;<span
                                class="hour-label text-muted text-right w-100 position-absolute"
                                v-for="h in hours"
                                :style="hourStyle(h)"
                            >
                                {{
                                    moment()
                                        .hour(parseInt(h))
                                        .minute(parseInt((h % 1) * 60))
                                        .format("h A")
                                }}&nbsp;
                            </span>
                        </div>
                    </div>
                    <div
                        v-for="d in daysOfWeek"
                        class="flex-grow-1 h-100 calendar-day"
                        :class="isBlackedOut(d) ? 'holiday' : 'bg-white'"
                        style="line-height: 1; flex-basis: 0; border: solid 1px #8f8f8f;"
                    >
                        <div
                            class="text-center font-weight-bold text-uppercase p-3 calendar-head bg-white"
                            :class="{ today: moment(d).dayOfYear() === moment().dayOfYear() }"
                        >
                            <span class="day">{{ d.format("DD") }}</span
                            ><br />
                            <span class="week">{{ d.format("ddd").toUpperCase() }}</span>
                        </div>
                        <div class="calendar-body position-relative" :style="dayStyle">
                            <div
                                v-if="isBlackedOut(d)"
                                :id="`blacked-out-${d.format('DD')}`"
                                class="m-1 p-1 pl-2 position-absolute calendar-entry calendar-appintment bg-white"
                                :style="{ top: 0, width: '95%' }"
                                v-html="getBlackoutDescription(d)"
                            ></div>
                            <div
                                v-for="a in getDayAppointments(d)"
                                :id="`appointment-${a.id}`"
                                class="m-1 p-1 pl-2 position-absolute calendar-entry"
                                :class="appointmentClass(a)"
                                :style="appointmentStyle(a)"
                                @click="
                                    (canEditAppointments && canEditSpecificAppointment(a)) ||
                                    canCompleteAppointment(a)
                                        ? editAppointment(a)
                                        : null
                                "
                            >
                                <div>
                                    <i
                                        v-if="a.contract_usage && a.contract_usage === 'failure'"
                                        class="fa fa-exclamation-triangle fa-fw text-danger"
                                        v-tooltip="
                                            `This appointment belongs to a contract that has exceeded its limit`
                                        "
                                    ></i>
                                    <i
                                        v-if="
                                            a.copay_value &&
                                                parseFloat(a.copay_value) > 0 &&
                                                !(
                                                    a.is_max_out_of_pocket_amount_met &&
                                                    a.is_deductible_amount_met
                                                )
                                        "
                                        class="fa fa-dollar fa-fw text-success"
                                        v-tooltip="
                                            `Copay value: ${helpers.formatMoney(a.copay_value)}`
                                        "
                                    ></i>
                                    <span
                                        style="color: #333;"
                                        :class="{
                                            'text-danger font-weight-bold': conflicted.includes(
                                                a.id
                                            ),
                                        }"
                                    >
                                        {{ moment(a.time_start_at).format("hh:mm A") }}-{{
                                            moment(a.time_end_at).format("hh:mm A")
                                        }} </span
                                    ><br />
                                    <span
                                        :class="conflicted.includes(a.id) ? 'break-words' : ''"
                                        v-html="getAppointmentParticipant(a)"
                                    ></span>
                                    <span :class="conflicted.includes(a.id) ? 'break-words' : ''">{{
                                        appointmentTypes.find(t => t.id === a.appointment_type_id)
                                            ? appointmentTypes.find(
                                                  t => t.id === a.appointment_type_id
                                              ).name
                                            : ""
                                    }}</span>
                                    <span v-if="a.notes">
                                        - {{ helpers.truncateText(a.notes, 240, "...") }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div
            class="col-12 px-0"
            :class="collapsed ? 'd-sm-none' : 'col-sm-4 col-md-3'"
            style="background-color: #65666A"
        >
            <div class="d-flex flex-column justify-content-start">
                <v-date-picker
                    class="picker-scale"
                    :class="collapsed ? 'd-none' : ''"
                    :attributes="attributes"
                    :is-inline="true"
                    v-model="selectedDate"
                >
                </v-date-picker>
            </div>
            <div
                v-if="typeof stats === 'object' && Object.keys(stats).length"
                class="bg-white mt-3 p-2"
            >
                <p class="small text-uppercase font-weight-bold mb-0">Hours</p>
                <p
                    v-for="k in Object.keys(stats)"
                    class="small d-flex justify-content-between align-center mb-0"
                    :class="collapsed ? 'flex-column' : ''"
                >
                    <span>{{ k }}: </span><span>{{ stats[k] }}</span>
                </p>
            </div>
            <div class="bg-white mt-3 mb-3 p-2">
                <p
                    class="small text-uppercase font-weight-bold mb-0"
                    :class="collapsed ? 'text-center' : ''"
                >
                    Calendar key
                </p>
                <span class="small d-flex justify-content-start align-items-center mb-0 pt-1"
                    ><i class="fa fa-square mr-3" style="color: #3ECA20;"></i>Data Entered &
                    Completed</span
                >
                <span class="small d-flex justify-content-start align-items-center mb-0 pt-1"
                    ><i class="fa fa-square mr-3" style="color: #33cbf9;"></i>Pending
                    Supervisor</span
                >
                <span class="small d-flex justify-content-start align-items-center mb-0 pt-1"
                    ><i class="fa fa-square mr-3" style="color: #DC00FF;"></i>No Session</span
                >
                <span class="small d-flex justify-content-start align-items-center mb-0 pt-1"
                    ><i class="fa fa-square mr-3" style="color: #F7A506;"></i>Late Data</span
                >
                <span class="small d-flex justify-content-start align-items-center mb-0 pt-1"
                    ><i class="fa fa-square mr-3" style="color: #8f8f8f;"></i>Not completed</span
                >
            </div>
        </div>

        <!--CREATE OR EDIT APPOINTMENT-->
        <schedule-new-appointment
            ref="appointmentModal"
            :visible="modal.visible"
            :title="modal.title"
            :size="modal.size"
            dusk="new-appointment"
            :organization="organization"
            :user="user"
            :centers="centers"
            :current-user-therapist="currentUserTherapist"
            :appointment-types="appointmentTypes"
            :appointment-templates="appointmentTemplates"
            :schedule-owner-prop="scheduleOwnerProp"
            :schedule-owner="scheduleOwner"
            :schedule-owner-list="scheduleOwnerList"
            :participants-list-prop="participantsListProp"
            :participants-list="participantsList"
            :organization-therapists="therapists"
            :therapist-patient-relations="therapistPatientRelations"
            :places-of-service="placesOfService"
            :blackout-dates="blackoutDates"
            @appointment-created="appointmentCreated"
            @close="resetModal"
            @set-title="setModalTitle($event)"
            @update-view="updateCalendarView"
        ></schedule-new-appointment>
    </div>
</template>

<script>
import TimePicker from "../ui/TimePicker";
import ScheduleNewAppointment from "./ScheduleNewAppointment";
import { fixDatePickers } from "../../plugins/fixDatePickers";
import { permissions } from "../../plugins/permissions";
import { calendarPresentation } from "./calendarPresentation";
import { helpers } from "../../plugins/helpers";

export default {
    name: "ScheduleCalendar",
    props: [
        "user",
        "currentUserTherapist",
        "therapists",
        "organization",
        "centers",
        "appointmentTypes",
        "appointmentTemplates",
        "directReports",
        "participantsList",
        "participantsListProp",
        "scheduleOwnerList",
        "scheduleOwnerProp",
        "therapistPatientRelations",
        "placesOfService",
    ],
    components: {
        ScheduleNewAppointment,
        TimePicker,
    },
    mixins: [fixDatePickers, permissions, calendarPresentation],
    data() {
        return {
            helpers,
            requestId: null,
            selectedDate: new Date(),
            workdays: [1, 2, 3, 4, 5], //1: Monday
            daysOfWeek: [],
            weekStart: this.moment().day(1),
            scheduleOwner: {},
            appointments: [],
            attributes: [],
            keys: [
                { name: "data_entered", color: "#3eca20" },
                { name: "pending_supervisor", color: "#33cbf9" },
                { name: "no_session", color: "#DC00FF" },
                { name: "late_data", color: "#F7A506" },
                { name: "not_completed", color: "#8F8F8F" },
            ],
            conflicted: [],
            modal: {},
            modals: [
                {
                    visible: false,
                    size: null,
                    title: "New Appointment",
                    type: 0,
                },
            ],
            stats: {},
            collapsed: false,

            showWeekends: false,
        };
    },

    mounted() {
        if (window.innerWidth < 768) {
            this.collapsed = true;
        }
        this.resetScale();
        this.workdays.forEach(d => {
            this.daysOfWeek.push(this.moment(this.weekStart).day(d));
        });
        this.selectComponentFromRequest();
        this.pickScheduleOwner();
    },

    computed: {
        hours() {
            let hours = [];
            let hour = Math.ceil(this.startHour); //only round hours
            while (hour < this.finishHour) {
                hours.push(hour);
                hour++;
            }
            return hours;
        },

        canSelectScheduleOwner() {
            switch (this.scheduleOwnerProp) {
                case "patient":
                    return this.canViewAllClients || this.canEditScheduleClient;
                case "therapist":
                    return (
                        this.canEditScheduleStaffAll ||
                        this.canEditScheduleStaffDirect ||
                        this.canViewAllStaff
                    );
            }
        },

        canCreateAppointments() {
            switch (this.scheduleOwnerProp) {
                case "patient":
                    return this.canEditScheduleClient;
                case "therapist":
                    if (this.canEditScheduleStaffAll) {
                        // For staff related permissions, we'll use canEdit(...) since we don't have canCreate(...)
                        return true;
                    }
                    if (
                        _.get(this.scheduleOwner, "supervisor_user.id", null) ===
                        _.get(this.user, "id", null)
                    ) {
                        // User whose supervisor is the logged user
                        return this.canEditScheduleStaffDirect;
                    }
                    if (
                        _.get(this.scheduleOwner, "user.id", null) === _.get(this.user, "id", null)
                    ) {
                        // User's own schedule
                        return this.canCreateOwnAppointment;
                    }
                    return false;
            }
        },

        canEditAppointments() {
            switch (this.scheduleOwnerProp) {
                case "patient":
                    if (
                        this.scheduleOwner &&
                        this.scheduleOwner.therapists &&
                        this.scheduleOwner.therapists.length
                    ) {
                        const therapists = this.scheduleOwner.therapists.map(t => t.id);
                        if (therapists.includes(this.user.id)) {
                            return true;
                        }
                    }
                    return this.canEditScheduleClient;
                case "therapist":
                    if (this.canEditScheduleStaffAll) {
                        return true;
                    }
                    if (
                        _.get(this.scheduleOwner, "supervisor_user.id", null) ===
                        _.get(this.user, "id", null)
                    ) {
                        // User whose supervisor is the logged user
                        return this.canEditScheduleStaffDirect;
                    }
                    if (
                        _.get(this.scheduleOwner, "user.id", null) === _.get(this.user, "id", null)
                    ) {
                        // User's own schedule
                        return this.canEditOwnAppointment;
                    }
                    return false;
            }
        },

        supervisedTherapistsIds() {
            const supervisedTherapists = this.therapists.filter(
                therapist =>
                    _.get(therapist, "supervisor_user.id", this.user.id, null) === this.user.id
            );
            return supervisedTherapists.map(t => t.id);
        },

        filteredAppointments() {
            switch (this.scheduleOwnerProp) {
                case "patient": // If the schedule owner is a patient, we can assume that the user has privileges to see that patient's appointments, determined on Schedule.vue
                    if (this.canViewAllStaff || this.canEditScheduleStaffAll) {
                        return this.appointments;
                    }
                    if (this.canEditScheduleStaffDirect) {
                        return this.appointments.filter(appointment => {
                            return (
                                this.supervisedTherapistsIds.includes(appointment.therapist_id) ||
                                this.supervisedTherapistsIds.includes(
                                    appointment.billing_therapist_id
                                ) ||
                                appointment.therapist_id === this.currentUserTherapist.id ||
                                appointment.billing_therapist_id === this.currentUserTherapist.id
                            );
                        });
                    }
                    return this.appointments.filter(
                        appointment =>
                            appointment.therapist_id === this.currentUserTherapist.id ||
                            appointment.billing_therapist_id === this.currentUserTherapist.id
                    );
                case "therapist": // In this case, we need to make sure that the user can see the patients in the selected therapist's schedule
                    if (this.canViewAllClients) {
                        return this.appointments;
                    }
                    return this.appointments.filter(
                        appointment =>
                            this.therapistPatientRelations
                                .map(relation => relation.patient_id)
                                .includes(appointment.patient_id) || !appointment.patient_id
                    );
            }
        },

        blackoutDates() {
            let blackoutDates = [];
            this.centers.forEach(
                center =>
                    (blackoutDates = [
                        ...blackoutDates,
                        ..._.get(center, "blackout_dates.dates.dates", []),
                    ])
            );
            return blackoutDates;
        },
    },

    watch: {
        selectedDate() {
            if (!this.selectedDate) {
                this.selectedDate = this.moment()
                    .day(1)
                    .hour(0)
                    .minute(0)
                    .toDate();
            }
            this.weekStart = this.moment(this.selectedDate).day(1);
            this.updateCalendarView();
        },

        scheduleOwner() {
            if (this.scheduleOwner && this.scheduleOwner.id) {
                this.updateCalendarView();
            }
        },

        scheduleOwnerList() {
            this.pickScheduleOwner();
        },

        "modal.visible"() {
            if (this.modal.visible) {
                setTimeout(this.$refs.appointmentModal.approveAppointment, 500);
            }
        },
    },

    methods: {
        isBlackedOut(day) {
            let blackoutDates = this.blackoutDates.map(date => date.date);
            return blackoutDates.includes(day.format("YYYY-MM-DD"));
        },

        getBlackoutDescription(day) {
            let dates = [];
            if (Array.isArray(this.blackoutDates)) {
                dates = this.blackoutDates.filter(
                    date => date.date === this.moment(day).format("YYYY-MM-DD")
                );
            }
            let description = "";
            dates.forEach(date => (description += date.description + "<br>"));
            return description;
        },

        setShowWeekends(showWeekends) {
            this.showWeekends = showWeekends;
            if (showWeekends) {
                this.$set(this, "workdays", [1, 2, 3, 4, 5, 6, 7]);
                this.collapsed = true;
            } else {
                this.$set(this, "workdays", [1, 2, 3, 4, 5]);
                this.collapsed = false;
            }
            this.updateCalendarView();
        },

        canCompleteAppointment(appointment) {
            if (this.canCompleteAllAppointments) {
                return true;
            }
            if (
                this.canCompleteOwnAppointments &&
                appointment.therapist_id === this.currentUserTherapist.id
            ) {
                return true; //TODO: the list of direct reports includes the own logged user (because of the staff page). Should it be removed?
            }
            if (this.canCompleteDirectAppointments) {
                return this.directReports
                    .map(therapist => therapist.id)
                    .includes(appointment.therapist_id);
            }
        },

        canEditSpecificAppointment(appointment) {
            //This acts in tandem with `canEditAppointments`
            if (appointment.status === "complete") {
                return this.canEditCompletedAppointments;
            }
            if (appointment.therapist_id === this.currentUserTherapist.id) {
                return this.canEditOwnAppointment;
            }
            return true;
        },

        pickScheduleOwner() {
            let user = null;
            if (Array.isArray(this.scheduleOwnerList)) {
                user = this.scheduleOwnerList.find(
                    t => _.get(t, "user.id", false) === this.user.id
                );
            }
            if (user) {
                this.scheduleOwner = user;
            } else if (this.scheduleOwnerList.length === 1) {
                this.scheduleOwner = this.scheduleOwnerList[0];
            }
        },

        getAppointmentDurationInMinutes(appointment) {
            return this.moment(appointment.time_end_at).diff(
                this.moment(appointment.time_start_at),
                "minutes"
            );
        },

        getAppointmentParticipant(appointment) {
            if (!appointment[this.participantsListProp + "_id"]) return; // No participant
            let participant = this.participantsList.find(
                p => p.id === appointment[this.participantsListProp + "_id"]
            ); // Find participant in participants list
            if (!participant)
                participant = this.therapists.find(
                    p => p.id === appointment[this.participantsListProp + "_id"]
                ); // Find participant in therapists list
            if (participant) {
                return participant.name;
            } else {
                // Appointment is orphaned
                return '<span class="text-danger">&lt;Deleted&gt;&nbsp;</span>-&nbsp;';
            }
        },

        selectComponentFromRequest() {
            const urlParams = new URLSearchParams(window.location.search);
            const patientId = parseInt(urlParams.get("patient_id"));
            const therapistId = parseInt(urlParams.get("therapist_id"));
            this.requestId = therapistId || patientId;
            if (patientId) this.$bus.$emit("set-schedule-component", "schedule-patient");
            if (therapistId) this.$bus.$emit("set-schedule-component", "schedule-staff");
            setTimeout(this.selectScheduleOwnerFromRequest, 1000);
            // Wait for component to be switched before fetching new schedule
        },

        selectScheduleOwnerFromRequest() {
            const owner = this.scheduleOwnerList.find(o => o.id === this.requestId);
            if (owner) {
                this.scheduleOwner = owner;
            }
            window.history.pushState({}, document.title, "/schedule");
        },

        getDayAppointments(d) {
            return this.filteredAppointments
                .filter(a => {
                    return (
                        this.moment(a.time_start_at).dayOfYear() === this.moment(d).dayOfYear() &&
                        this.moment(a.time_start_at).year() === this.moment(d).year()
                    );
                })
                .sort(
                    (before, after) =>
                        this.moment(before.time_start_at).format("X") >
                        this.moment(after.time_start_at).format("X")
                );
        },

        applyFilters() {
            let filters = [];
            filters.push({
                key: "time_start_at",
                value: this.moment(this.selectedDate)
                    .day(this.workdays[0])
                    .hour(0)
                    .minute(0)
                    .second(0)
                    .format("YYYY-MM-DD HH:mm:ss"),
                operator: "gte",
            });
            filters.push({
                key: "time_start_at",
                value: this.moment(this.selectedDate)
                    .day(this.workdays[this.workdays.length - 1])
                    .hour(23)
                    .minute(59)
                    .second(59)
                    .format("YYYY-MM-DD HH:mm:ss"),
                operator: "lte",
            });
            this.fetchAppointments(filters);
        },

        fetchAppointments(filters) {
            this.appointments = [];
            this.resetScale();
            let params = {
                params: {
                    filter_groups: [
                        {
                            filters: [],
                        },
                    ],
                },
            };
            if (filters) {
                filters.forEach(function(filter) {
                    params.params.filter_groups[0].filters.push(filter);
                });
            }
            axios
                .get(
                    `/api/organizations/${this.organization.id}/scheduling/appointments/?${
                        this.scheduleOwnerProp
                    }_id=${this.scheduleOwner.id}&stats`,
                    params
                )
                .then(r => {
                    this.makePickerAttributes(r.data.data);
                    this.appointments = r.data.data;
                    this.setScheduleScale(r.data.data);
                    this.stats = r.data.meta ? r.data.meta.stats : {};
                    this.conflicted = r.data.meta ? r.data.meta.conflicted_appointments : [];
                })
                .catch(e => {
                    console.error(e);
                });
        },

        openNewAppointmentModal(edit) {
            this.modal = this.modals[0];
            this.modal.visible = true;
            this.modal.title = edit ? "Edit Appointment" : "New Appointment";
            this.removePickerMinWidth();
        },

        editAppointment(appointment) {
            const appointmentCopy = { ...appointment }; // Let's not mutate the original object
            const payload = this.prepareEditPayload(appointmentCopy);
            this.$refs.appointmentModal.parseEditPayload(payload);
            this.openNewAppointmentModal(true);
        },

        prepareEditPayload(appointment) {
            let payload = appointment;

            if (appointment.recurrence) {
                this.$refs.appointmentModal.recurrenceClean = JSON.parse(appointment.recurrence); // Copy original data to check for changes
                payload.recurrence = JSON.parse(appointment.recurrence);
            }

            if (payload.recurrence) {
                switch (payload.recurrence.interval) {
                    case 2:
                        this.$refs.appointmentModal.frequency = "WEEKLY2";
                        break;
                    case 1:
                        this.$refs.appointmentModal.frequency = payload.recurrence.frequency;
                }

                payload.recurrence.frequency = appointment.recurrence.frequency.toLowerCase();
                payload.recurrence.frequency =
                    appointment.recurrence.frequency.charAt(0).toUpperCase() +
                    appointment.recurrence.frequency.slice(1);
                let selectedDays = [];
                ["MO", "TU", "WE", "TH", "FR", "SA"].forEach(d =>
                    selectedDays.push(payload.recurrence.days_of_week.includes(d))
                );
                this.$refs.appointmentModal.selectedDays = selectedDays;
                payload.recurrence.end_at = new Date(payload.recurrence.end_at.replace(/ /g, "T")); // For Safari Compatibility
            } else {
                payload.recurrence = {
                    frequency: null,
                    interval: null,
                    days_of_week: [],
                };
            }

            payload.startDate = new Date(payload["time_start_at"].replace(/ /g, "T")); // For Safari Compatibility
            payload.startTime = this.moment(payload["time_start_at"]).format("hh:mm A");
            payload.endDate = new Date(payload["time_end_at"].replace(/ /g, "T")); // For Safari Compatibility
            payload.endTime = this.moment(payload["time_end_at"]).format("hh:mm A");
            payload.endTimeFixed = this.moment(payload["time_end_at"]).format("hh:mm A");
            if (payload.break_time_start_at && payload.break_time_end_at) {
                payload.breakTime = {};
                payload.breakTime.enabled = true;
                payload.breakTime.startTime = this.moment(payload.break_time_start_at).format(
                    "hh:mm A"
                );
                const endTime = this.moment(payload.break_time_end_at);
                payload.breakTime.duration = endTime.diff(
                    this.moment(payload.break_time_start_at),
                    "minutes"
                );
            }
            if (payload.lunch_time_start_at && payload.lunch_time_end_at) {
                payload.lunchTime = {};
                payload.lunchTime.enabled = true;
                payload.lunchTime.startTime = this.moment(payload.lunch_time_start_at).format(
                    "hh:mm A"
                );
                const endTime = this.moment(payload.lunch_time_end_at);
                payload.lunchTime.duration = endTime.diff(
                    this.moment(payload.lunch_time_start_at),
                    "minutes"
                );
            }
            return payload;
        },

        resetModal() {
            this.modal = {};
            this.$refs.appointmentModal.showCompleteAppointment = false;
            this.$refs.appointmentModal.clearAppointment();
        },

        setModalTitle(title) {
            this.modal.title = title;
        },

        makePickerAttributes(appointments) {
            this.attributes = [];
            this.attributes.push({
                highlight: {
                    backgroundColor: "#ff7299",
                },
                contentStyle: {
                    color: "white",
                },
                dates: [
                    {
                        start: new Date(this.moment(this.selectedDate).day(1)),
                        end: new Date(
                            this.moment(this.selectedDate).day(
                                this.workdays[this.workdays.length - 1]
                            )
                        ),
                    },
                ],
            });
            this.keys.forEach(k => {
                let attrib = {};
                attrib.dot = { backgroundColor: k.color };
                attrib.dates = [];
                appointments
                    .filter(a => a.calendar_key === k.name)
                    .forEach(a => {
                        attrib.dates.push(
                            new Date(
                                this.moment(a.time_start_at).year(),
                                this.moment(a.time_start_at).month(),
                                this.moment(a.time_start_at).date()
                            )
                        );
                    });
                this.attributes.push(attrib);
            });
            setTimeout(this.getMaxDayHeight, 500);
        },

        updateCalendarView() {
            this.daysOfWeek = [];
            this.weekStart = this.moment(this.selectedDate).day(1);
            this.workdays.forEach(d => {
                this.daysOfWeek.push(this.moment(this.weekStart).day(d));
            });
            this.applyFilters();
        },

        appointmentCreated() {
            this.updateCalendarView();
            this.resetModal();
        },
    },
};
</script>

<style scoped lang="scss">
.calendar-appointment {
    transition: all 0.4s;
}
.calendar-appointment:hover {
    //overflow: visible;
    height: unset !important;
}
.hour-label {
    font-size: 60%;
    text-wrap: none;
    white-space: nowrap;
}

.profile-image {
    min-height: 2.5rem;
    max-height: 2.5rem;
    min-width: 2.5rem;
    max-width: 2.5rem;
}

.calendar-head {
    color: #a2a6a9;
    > .day {
        font-size: 2rem;
    }
    > .week {
        font-size: 1.2rem;
    }
}
.calendar-head.today {
    color: #389992;
}

.calendar-day.holiday {
    background: #c9c9c9;
}
.calendar-day.holiday > .calendar-head {
    color: #dc3545;
}
.calendar-body {
    transform-origin: top;
}

.calendar-entry {
    transition: all 0.3s;
    font-size: 80%;
    color: #a2a6a9;
    opacity: 1;
    background: white;
    transform-origin: top;
    overflow: hidden;
}

.calendar-entry:hover {
    background: white;
    opacity: 1;
    width: 95%;
    z-index: 500 !important;
}

.pending_supervisor {
    box-shadow: inset 4px 0 0 0 #33cbf9;
}
.pending_supervisor:hover {
    box-shadow: inset 4px 0 0 0 #33cbf9, 0 0 2px 2px rgba(162, 166, 169, 0.33);
}
.data_entered {
    box-shadow: inset 4px 0 0 0 #3eca20;
}
.data_entered:hover {
    box-shadow: inset 4px 0 0 0 #3eca20, 0 0 2px 2px rgba(162, 166, 169, 0.33);
}
.no_session {
    box-shadow: inset 4px 0 0 0 #dc00ff;
}
.no_session:hover {
    box-shadow: inset 4px 0 0 0 #dc00ff, 0 0 2px 2px rgba(162, 166, 169, 0.33);
}
.late_data {
    box-shadow: inset 4px 0 0 0 #f7a506;
}
.late_data:hover {
    box-shadow: inset 4px 0 0 0 #f7a506, 0 0 2px 2px rgba(162, 166, 169, 0.33);
}
.not_completed {
    box-shadow: inset 4px 0 0 0 #8f8f8f;
}
.not_completed:hover {
    box-shadow: inset 4px 0 0 0 #8f8f8f, 1px 1px 1px 1px rgba(162, 166, 169, 0.33);
}
.appointment-detail {
    font-size: 80%;
    width: 16rem;
    z-index: 3;
    background-color: white;
}

.dow {
    min-height: 1.5rem;
    max-height: 1.5rem;
    min-width: 1.5rem;
    max-width: 1.5rem;
    border: solid 1px #8f8f8f;
    display: flex;
    justify-content: center;
    align-items: center;
}
.dow.enabled {
    color: #389992;
    border-color: #389992;
}

.overlay {
    background: rgba(64, 64, 64, 0.3);
    min-width: 100%;
    min-height: 100%;
    z-index: 2;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

@media (min-width: 576px) {
    .picker-scale {
        transform: scale(0.5, 0.55);
        transform-origin: left;
        background-color: white;
        width: 200%;
        //margin-top: -35%;
    }
}

.break-words {
    word-wrap: break-word;
}

.conflicted:not(:only-child) {
    width: 47%;
}

.to-right {
    right: 0;
}

.short-duration:nth-child(even) {
    width: 88%;
    left: 8%;
}
</style>
